import { UserService } from '../services/common/UserService';
import { useSelector } from 'react-redux';
import LanguageSlice from '../common/slices/LanguageSlice';

export default function useLanguages() {
    const userAllowedLanguages = UserService.getAllowedLanguages() || [];
    const currentlyAllowedLanguages = useSelector(
        LanguageSlice.state.getAllowedLocales,
    );
    return currentlyAllowedLanguages.length > 0
        ? currentlyAllowedLanguages
        : userAllowedLanguages;
}
